
import 'pages/reviews/reviews-list.tag'
import 'pages/reviews/review-edit.tag'
import 'pages/comments/comments-list.tag'
import 'pages/comments/comment-edit.tag'
riot.tag2('user-reviews', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}" title="{title}"><a href="#reviews/{link}"><i class="{icon}"></i><span class="hidden-xs">&nbsp;{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <reviews-list if="{tab == &quot;reviews&quot; &amp;&amp; !edit}"></reviews-list>\n    <review-edit if="{tab == &quot;reviews&quot; &amp;&amp; edit}"></review-edit>\n    <comments-list if="{tab == &quot;comments&quot; &amp;&amp; !edit}"></comments-list>\n    <comment-edit if="{tab == &quot;comments&quot; &amp;&amp; edit}"></comment-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.tab = '';
self.edit = false;

self.tabs = [{ title: 'Отзывы', name: 'reviews', link: '', permission: 'reviews', icon: 'fa fa-comment-o' }, { title: 'Комментарии', name: 'comments', link: 'comments', permission: 'comments', icon: 'fa fa-comments-o' }];

var route = riot.route.create();
route('/reviews', function () {
    self.edit = false;
    self.tab = 'reviews';
    self.update();
});

route('/reviews/([0-9]+)', function (id) {
    observable.trigger('review-edit', id);
    self.notFound = false;
    self.tab = 'reviews';
    self.edit = true;
    self.update();
});

route('/reviews/new', function () {
    self.update({ edit: true, notFound: false });
    observable.trigger('review-new');
});

route('/reviews/comments', function () {
    self.notFound = false;
    self.edit = false;
    self.tab = 'comments';
    self.update();
});

route('/reviews/comments/([0-9]+)', function (id) {
    observable.trigger('comment-edit', id);
    self.notFound = false;
    self.tab = 'comments';
    self.edit = true;
    self.update();
});

route('/reviews/comments/new', function () {
    self.notFound = false;
    self.edit = true;
    self.tab = 'comments';

    observable.trigger('comment-new');
    self.update();
});

route('/reviews/comments..', function () {
    self.notFound = true;
    self.update();
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/user-reviews.tag